import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { DeclarativeModal } from 'seagull';
import { useStateFromUrl } from '~/hooks/useStateFromUrl';
import { useInvoiceChangesObservable } from '~/providers/InvoiceChangesObservableProvider';
import { useOptimizedMobileViewport } from '~/providers/MobileViewportWidthProvider';
import { MobileDeviceEnhancer } from '../MobileDeviceEnhancer/MobileDeviceEnhancer';
import FullPageInvoice from './FullPageInvoice';
import { invoiceSearchParam, relationshipSearchParam } from './FullPageInvoice.utils';
function MobileWrapper(param) {
    let { children } = param;
    useOptimizedMobileViewport(true);
    return /*#__PURE__*/ _jsx(MobileDeviceEnhancer, {
        children: children
    });
}
export default function FullPageInvoiceOpener(props) {
    const { urlState: { invoice, relationship }, changeUrlState } = useStateFromUrl({
        [invoiceSearchParam]: {
            defaultValue: ''
        },
        [relationshipSearchParam]: {
            defaultValue: ''
        }
    });
    const { notify } = useInvoiceChangesObservable();
    useEffect(()=>{
        if (invoice && !relationship) {
            changeUrlState({
                invoice: ''
            });
        } else if (!invoice && relationship) {
            changeUrlState({
                relationship: ''
            });
        }
    }, [
        invoice,
        relationship
    ]);
    const defaultContent = (param)=>{
        let { dismissModal } = param;
        return /*#__PURE__*/ _jsx(FullPageInvoice, {
            invoiceId: invoice,
            relationshipId: relationship,
            dismissModal: dismissModal,
            onRefresh: notify
        });
    };
    const renderContent = props.content || defaultContent;
    const content = (modalProps)=>/*#__PURE__*/ _jsx(MobileWrapper, {
            children: renderContent(modalProps)
        });
    return /*#__PURE__*/ _jsx(DeclarativeModal, {
        biName: "full_page_invoice",
        isOpen: !!(invoice && relationship),
        treatAsPage: true,
        content: content,
        onClose: ()=>{
            changeUrlState({
                invoice: '',
                relationship: ''
            }, {
                push: true
            });
        }
    });
}
